import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { App, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';

import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AuthProvider } from '../../../../providers/auth/auth';
import { CommonProvider } from '../../../../providers/common';
import { EmployeeRhProvider } from '../../../../providers/employeerh/employeerh';
import { PostProvider } from '../../../../providers/post/post';
import { TBRProvider } from '../../../../providers/tbr/tbr';
import { WellBeingProvider } from '../../../../providers/wellbeing/wellbeing';
import { RhDrivePage } from '../drive/rh-drive';
import { RhAmazementPage } from '../rh-amazement/rh-amazement';
import { RhBarometerPage } from '../rh-barometer/rh-barometer';
import { RhCustomInterview } from '../rh-custominterview/rh-custominterview';
import { RhCustomInterviewSignature } from '../rh-custominterview/rh-custominterview-signature/rh-custominterview-signature';
import { RhCustomInterviewGoalsPage } from '../rh-custominterview/rh_customerinterview-goals/rh-custominterview-goals';
import { RhGoalsSignList } from '../rh-goals/goals-sign-list/goals-sign-list';
import { RhGoalsPage } from '../rh-goals/rh-goals';
import { RhInterviewPage } from '../rh-interview/rh-interview';
import { RhInterviewGoalsPage } from '../rh-interview/rh-interview-goals/rh-interview-goals';
import { RhInterviewListPage } from '../rh-interview/rh-interview-list/rh-interview-list';
import { RhInterviewManagerPage } from '../rh-interview/rh-interview-manager/rh-interview-manager';
import { RhKnowledgePage } from '../rh-knowledge/rh-knowledge';
import { RhManagerSkillSearchPage } from '../rh-managerskillsearch/rh-managerskillsearch';
import { RhOffboardingPage } from '../rh-offboarding/rh-offboarding';
import { RhSkillSearchPage } from '../rh-skillsearch/rh-skillsearch';
import { RhSkillsRatingPage } from '../rh-skillsrating/rh-skillsrating';
import { RhTasksPage } from '../rh-tasks/rh-tasks';
import { RhRHCSPage } from '../rhcs/rh-rhcs';

@Component({
  selector: 'page-rh-dashboard',
  templateUrl: 'rh-dashboard.html',
})
export class RhDashboardPage implements OnInit {


  quicklinks: any = null;
  activeProcess: any = null;
  interview: any = null
  showHeader: boolean = true;
  companyLogo: string = null;
  // Well being
  displayWellBeing = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public storageProvider: Storage,
    private commonProvider: CommonProvider,
    public app: App,
    public authProvider: AuthProvider,
    public postProvider: PostProvider,
    public tbrProvider: TBRProvider,
    public employeeRhProvider: EmployeeRhProvider,
    private iab: InAppBrowser,
    public modalCtrl: ModalController,
    private viewCtrl: ViewController,
    public wellBeingProvider: WellBeingProvider
  ) { }


  ngOnInit() {
    this.loadDatas();
  }

  loadDatas() {

    // Load quicklinks
    this.employeeRhProvider.getQuicklinks().subscribe((res) => {
      if (res.success) {
        this.quicklinks = res.data;
      }
    })

    // Active process
    this.employeeRhProvider.checkActiveProcess().subscribe((res) => {
      if (res.success) {
        this.activeProcess = res.data;
        if (res.data.companyLogo) {
          this.companyLogo = `${this.commonProvider.s3PublicUrl}${res.data.companyLogo.s3key}`
        }
      }
    })

    // Get interview, we're not using the activeprocess for this particular one because its an headache :)
    this.employeeRhProvider.getUserInterview().subscribe((res) => {
      if (res.success) {
        this.interview = res.data;
      }
    })

    // Check if modal-header needs to show
    this.showHeader = this.authProvider.user.options.settings_social_network_enabled

    // Wellbeing
    this.wellBeingProvider.shouldFill().subscribe((res) => {
      if (res.success) {
        this.displayWellBeing = res.data;
      }
    })

  }


  // Utils Functions
  goToUrl(url) {
    const browser = this.iab.create(url, '_system', 'location=yes')
  }

  goToRHCS(campaign) {
    let modalView = this.modalCtrl.create(RhRHCSPage, { campaign: campaign }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToAmazement() {
    let modalView = this.modalCtrl.create(RhAmazementPage, null, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToOffboarding() {
    let modalView = this.modalCtrl.create(RhOffboardingPage, null, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToDrive() {
    let modalView = this.modalCtrl.create(RhDrivePage, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToInterview() {
    let modalView = this.modalCtrl.create(RhInterviewPage, { interview: this.interview }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToManagerInterview(item) {
    let modalView = this.modalCtrl.create(RhInterviewManagerPage, { interview: item }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToCustomInterview(interview, isManager, goals) {
    let modalView = this.modalCtrl.create(RhCustomInterview, { interview: interview, isManager: isManager, goals: goals }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToCustomInterviewSignature(interview) {
    let modalView = this.modalCtrl.create(RhCustomInterviewSignature, { interview: interview }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToInterviewList() {
    let modalView = this.modalCtrl.create(RhInterviewListPage, null, {
      cssClass: 'my-popover'
    });
    modalView.present().then(() => { });
  }

  goToSkillSearch() {
    if (this.activeProcess.isSkillSearchDisabled) {
      return;
    }
    let modalView = this.modalCtrl.create(RhSkillSearchPage, null, {
      cssClass: 'my-popover'
    });
    modalView.present().then(() => { });
  }

  goToManagerSkillSearch() {
    let modalView = this.modalCtrl.create(RhManagerSkillSearchPage, null, {
      cssClass: 'my-popover'
    });
    modalView.present().then(() => { });
  }

  goToSkillsRating() {
    let modalView = this.modalCtrl.create(RhSkillsRatingPage, {}, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToManagerGoals(item) {
    let modalView = this.modalCtrl.create(RhInterviewGoalsPage, { interview: item }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToBarometer(barometer) {
    let modalView = this.modalCtrl.create(RhBarometerPage, { barometer_id: barometer.id }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToGoals(isUserManager) {
    let modalView = this.modalCtrl.create(RhGoalsPage, { isUserManager }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToTasks() {
    let modalView = this.modalCtrl.create(RhTasksPage, {}, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToKnowledge(domType) {
    let modalView = this.modalCtrl.create(RhKnowledgePage, { domType }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }



  goToGoalsSignature(list) {
    let modalView = this.modalCtrl.create(RhGoalsSignList, { list }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }

  goToPRHCIManagerGoals(item) {
    let modalView = this.modalCtrl.create(RhCustomInterviewGoalsPage, { interview: item }, {
      cssClass: 'my-popover'
    });
    modalView.onDidDismiss(() => {
      this.loadDatas()
    })
    modalView.present().then(() => { });
  }


  // Well being
  setWellBeing(value) {
    console.log(value)
    this.wellBeingProvider.saveReport(value).subscribe((res) => {
      if (res.success) {
        this.displayWellBeing = false;
      }
    })
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/_rh/dashboard/rh-dashboard.ts